<template>
    <div >
        <div class="bilIndex">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="换票发布" name="first">
                    <!-- <Release/> -->
                </el-tab-pane>
                <el-tab-pane label="普通发布" name="second">
                    <!-- <Release/> -->
                </el-tab-pane>
                <el-tab-pane label="连票号发布" name="third">
                    <!-- <Serial></Serial> -->
                </el-tab-pane>
            </el-tabs>
            <Isticket v-if="showCon==1"/>
            <Release v-if="showCon==2"/>
            <Serial v-if="showCon==3"></Serial>
        </div>
    </div>
</template>

<script>
// import topbar from '@/components/topbar'
// import foot from '@/components/footer'
import Isticket from './issticket'
import Release from './release'
import Serial from './serial'
export default {
    components:{
        Isticket,
        Release,
        Serial
    },
    data() {
        return {
            activeName: 'first',
            showCon:1
        };
    },
    methods: {
        handleClick(tab, event) {
            if(tab.label=='换票发布'){
                this.showCon=1
            }else if(tab.label=='普通发布'){
                this.showCon=2
            }else{
                this.showCon=3
            }
        }
    }
}
</script>

<style  scoped>
.bilIndex{
    width: 1200px;
    /* margin: auto; */
    height: auto;
    margin-top: 0px;
    margin-bottom: 20px;
}
.bilIndex>>>.el-tabs__header{
    background: #fff;
    padding: 0 20px;
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/bilsindex.vue